
import { computed, defineComponent, ref, watch, SetupContext } from 'vue'
import appHost from '@/utils/app'
import { Toast, Loading } from 'vant'
import { useRouter } from 'vue-router'
import { GetNetworkpointDetail } from '@/apis/fault'
import { parseNetworkPoint } from '@/utils/dataFactory'
import getRoute from '@/compositions/route'
import { NetworkpointItem } from '@/types/fault'
import { UserLocationInfoStorage } from '@/storage/common'
import { AuthLocationInfoType } from '@/types/public'
import { useStore } from 'vuex'
import NameTag from '@/components/network-point/name-tag.vue'

export default defineComponent({
  name: 'Networkpoint-Detail',
  components: {
    VanLoading: Loading,
    NameTag,
  },
  emits: ['setCenter'],
  setup(props, context) {
    const store = useStore()
    const router = useRouter()
    const { params, query } = getRoute()
    const storageData = UserLocationInfoStorage.get<AuthLocationInfoType>()

    const isLoading = ref(false)
    const item = ref(null)
    const getDetail = async () => {
      isLoading.value = true
      try {
        const result: NetworkpointItem = await GetNetworkpointDetail(
          (params.value?.guid as string) || '',
          {
            type: (query?.value?.type as string) || '',
            lng: Number(storageData?.lng || 0),
            lat: Number(storageData?.lat || 0),
          }
        )
        const list = [result]
        list.forEach((it: any) => parseNetworkPoint(it))
        item.value = result
        context.emit('setCenter', [item.value.lng, item.value.lat])
        isLoading.value = false
      } catch (err: any) {
        isLoading.value = false
        const message: string = err.message
        Toast(message)
        console.error(message)
      }
    }
    const showUpdateing = computed(() => {
      return item.value && item.value.status === false && item.value.type === 'AUTH_WAREHOUSE'
    })
    const guid = computed(() => {
      return params.value?.guid || ''
    })

    watch(
      guid,
      () => {
        if (!guid.value) return
        getDetail()
      },
      { immediate: true }
    )
    const onCallPoint = () => {
      appHost.postCallPhone(item.value?.contact_phone || '', item.value?.name || '')
    }
    const onNavigatePoint = () => {
      const { address = '', lng = 0, lat = 0 } = item.value
      appHost.postMapNavigation({ address, lng, lat })
    }
    const onTodevices = () => {
      if (!item.value?.status) return
      const id: string = Date.now().toString()
      store.commit('setFaultBill', {
        id,
        networkpoint: item.value,
      })
      router.push({ name: 'devices', query: { from: 'networkpoint-detail' } })
    }
    const onToBackUp = () => {
      router.push({ name: 'networkpoints-devices', params: { guid: item.value?.guid || '' } })
    }

    return {
      isLoading,
      item,
      onCallPoint,
      onNavigatePoint,
      onTodevices,
      onToBackUp,
      showUpdateing,
    }
  },
})
